import React from 'react';
import '../styles/NavBar.css'; 
import logo from '../assets/logo-stanm.png';

function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        <a className="navbar-brand" href="#inicio">
          <img src={logo} alt="Logo" height="40" /> {/* Cambia logo.png por tu archivo */}
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="#quienes-somos">Quiénes Somos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#mision">Misión y Visión</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#experiencia">Experiencia</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#servicios">Servicios</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contacto">Contacto</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;